import { apiRequest } from './apiClient.js';
import type { FamilyPack } from '../types/family.js';
import { coalesceRequest } from './requestCoalescer.js';

export type { FamilyPack, FamilyPackMember } from '../types/family.js';

export function getFamilyPack(): Promise<FamilyPack> {
  return coalesceRequest('family-pack', () => apiRequest<FamilyPack>('/api/family-pack'));
}

export function createFamilyPack(name: string): Promise<FamilyPack> {
  return apiRequest<FamilyPack>('/api/family-pack', {
    method: 'POST',
    body: { name },
  });
}

export function inviteFamilyMember(
  email: string,
  invitedAsChild = false
): Promise<{ invitation_url?: string }> {
  return apiRequest<{ invitation_url?: string }>('/api/family-pack/invite', {
    method: 'POST',
    body: { email, invitedAsChild },
  });
}

export function joinFamilyPack(invitationCode: string): Promise<{ success?: boolean }> {
  return apiRequest<{ success?: boolean }>(`/api/family-pack/join/${encodeURIComponent(invitationCode)}`, {
    method: 'POST',
    body: {},
  });
}

export function leaveFamilyPack(): Promise<{ success?: boolean }> {
  return apiRequest<{ success?: boolean }>('/api/family-pack/leave', {
    method: 'POST',
    body: {},
  });
}
